import Vue from 'vue'
import {find, propEq} from 'ramda'

Vue.filter('findPropEg', function(value, obj) {
  return find(propEq(obj), value)
})
